module.exports = __webpack_public_path__ + "static/img/product_finance_vx.26e75de.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_finance_vx.svg
// module id = Xwi4
// module chunks = 0